import { redirect } from '@tanstack/react-router'

/**
 * Admin authentication
 * @param context
 */
export const adminAuth = ({ context }) => {
  const { client, setAuthUser } = context
  return client
    .reAuthenticate(true)
    .then((response: any) => {
      if (!response?.assettrak_access?.system_admin) {
        throw new Error('Unauthorized')
      }
      context.authUser = response.assettrak_access
      setAuthUser(response.assettrak_access)
      return context
    })
    .catch((error: any) => {
      console.error(error)
      throw redirect({
        to: '/',
        search: {
          redirect: window.location.pathname
        }
      })
    })
}
